/**
 * We use the standard pusher-js module to support pusher on web environments.
 * @see: https://github.com/pusher/pusher-js
 */
import Pusher from 'pusher-js/with-encryption';

export default Pusher;
